import {
	AutoConvertDefinition,
	AutoConvertMacroAttributesMap,
	AutoConvertMacroAttributes,
} from '../types';

export const convertLinkToMacroNode = (
	link: string,
	autoConvertDefinitions: AutoConvertDefinition[],
	macroAttributesMap: AutoConvertMacroAttributesMap,
): null | AutoConvertMacroAttributes => {
	const matchedAutoConvertDefinition: undefined | AutoConvertDefinition =
		autoConvertDefinitions.find((acd) => {
			return !!link.match(acd.matcher);
		});
	if (matchedAutoConvertDefinition) {
		const { extensionKey } = matchedAutoConvertDefinition;
		const macroAttributes = macroAttributesMap[extensionKey];
		// Clone the object here to avoid mutating the original object
		const convertedMacroAttributes: AutoConvertMacroAttributes = structuredClone(macroAttributes);
		convertedMacroAttributes.attrs.parameters.autoConvertLink = link;

		return convertedMacroAttributes;
	} else {
		return null;
	}
};
